import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import { constants } from '@yola/subscription-manager-js';
import classNames from 'classnames';
import useMatchBreakpoint from '../../common/hooks/use-match-breakpoint';
import breakpoints from '../../common/constants/breakpoints';
import configStorage from '../../configuration/config-storage';
import planNameWithReinforcement from '../../common/constants/plan-name-with-reinforcement';
import { t } from '../../localization';
import AvatarList from '../common/components/avatar-list';
import Rating from '../common/components/rating';
import { CUSTOMERS_AMOUNT } from '../common/constants/common';
import avatars from '../common/constants/avatars';

const {
  SubscriptionType: { B2C_HOSTING_GOLD },
} = constants;

const { ActionButton, Paragraph, Heading, IconButton, HorizontalStack, Stack } = designSystem;

const DifmOfferBanner = ({ partnerName, planName, onUpgrade, onClose }) => {
  const { cdnUrl } = configStorage.get();

  const isMatchDesktop = useMatchBreakpoint(breakpoints.XL);
  const isGoldReinforcementAvailable = planName === planNameWithReinforcement[B2C_HOSTING_GOLD];
  const avatarImages = useMemo(
    () => [
      `${cdnUrl}${avatars.AVATAR_3}`,
      `${cdnUrl}${avatars.AVATAR_2}`,
      `${cdnUrl}${avatars.AVATAR_5}`,
    ],
    [cdnUrl]
  );

  const classes = classNames('ws-difm-offer-banner', {
    'ws-difm-offer-banner--with-reinforcement': isGoldReinforcementAvailable,
  });

  return (
    <div className={classes}>
      <div className="ws-difm-offer-banner__content-wrapper">
        <div className="ws-difm-offer-banner__content">
          <Heading type="heading-6" isUppercase appearance="gradient">
            {t('limited-time offer')}
          </Heading>
          <Heading {...(isMatchDesktop ? { type: 'heading-4' } : { type: 'heading-6' })}>
            {t('Get a professional website built for you with {partnerName}', {
              partnerName: '',
            })}
            &nbsp;
            <span className="ws-difm-offer-banner__partner-name">
              {partnerName}&nbsp;
              <span className="ws-difm-offer-banner__plan-name">{planName}</span>
            </span>
          </Heading>
          {isMatchDesktop && (
            <HorizontalStack gap="spacing-3-xs" verticalAlign="center">
              <AvatarList images={avatarImages} size={40} shift={20} />
              <Stack>
                <Rating stars={5} size={16} />
                <Paragraph size="small" appearance="medium-emphasis">
                  {t('Trusted by {customers}+ customers', {
                    customers: CUSTOMERS_AMOUNT,
                  })}
                </Paragraph>
              </Stack>
            </HorizontalStack>
          )}
          <ActionButton
            label={t('Upgrade to {planName}', { planName })}
            appearance="gradient"
            format="solid"
            onClick={onUpgrade}
          />
          <IconButton glyph="close" onClick={onClose} transparent />
        </div>
      </div>
    </div>
  );
};

DifmOfferBanner.propTypes = {
  partnerName: PropTypes.string.isRequired,
  planName: PropTypes.string.isRequired,
  onUpgrade: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DifmOfferBanner;
